// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"235":"4993320e","830":"c38f44ad"}[chunkId] + ".chunk.js";
};